<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.institutions', 1) }}
                    </h3>
                </div>
            </div>

            <div class=" " :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form  @reset="onReset" v-if="show">
                    <div class=" " :class="[ mobileView ? '' : 'container']">
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="name-group"
                                        :label="$t('message.name')"
                                        label-for="name"
                                >
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.name.$model"
                                            :state="$v.form.name.$dirty ? !(errorshasField('name') || $v.form.name.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('name')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.name.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.name.minLength">
                                        {{ $t('message.minCharacters', { n: 3}) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('name')">
                                        {{ getErrorsField('name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="adresse-group"
                                        :label="$t('message.adresse')"
                                        label-for="name"
                                >
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.adresse.$model"
                                            :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.adresse.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.adresse.minLength">
                                        {{ $t('message.minCharacters', { n: 3}) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>


                            <b-col sm="12">
                                <b-form-group
                                        id="description-group"
                                        :label="$t('message.description')"
                                        label-for="description"
                                >
                                    <b-form-textarea
                                            id="description"
                                            v-model="$v.form.description.$model"
                                            :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                            required
                                            placeholder="localisation"
                                            @focus="clearErrorField('description')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="!$v.form.description.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                        {{ getErrorsField('description') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="upload-group"
                                        :label="$t('message.uploadFile')"
                                        label-for="upload"
                                >
                                    <b-form-file
                                            id="upload"
                                            :state="$v.form.logo.$dirty ? !$v.form.logo.$error : null"
                                           
                                            :file-name-formatter="formatNames"
                                            @change="setImage"
                                    ></b-form-file>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-container fluid class="p-4">
                                    <b-row id="image">
                                        <b-col>
                                            <b-img-lazy
                                                    class="img-preview"
                                                    thumbnail
                                                    :src="imageSrc(form.logo)"
                                                    fluid-grow
                                                    alt=""
                                            ></b-img-lazy>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center" v-if="can || hasAssistante">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {minLength, required} from 'vuelidate/lib/validators';

    export default {
        name: "AddInstitution",

        computed: {
            ...mapGetters(["errors",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },
        },

        data() {
            return {
                mobileView: true,
                form: {
                    name: '',
                    description: '',
                    logo:'',
                    adresse:'',
                },
                show: true
            }
        },

        methods: {
            handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
            formatNames(files) {
                return files[0].name
            },

            setImage(event) {
                this.form.logo = event.target.files[0];
            },

            imageSrc(img) {
                if (img) {
                    return URL.createObjectURL(img);
                }

                return '';
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let formData = new FormData();

                    formData.append('name', this.form.name);
                    formData.append('description', this.form.description);
                    formData.append('adresse', this.form.adresse);
                    formData.append('logo', this.form.logo);

                    let successMessage = this.$i18n.t('message.institutionCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createInstitution', { args:formData, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.name = '';
                this.form.description = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3)

                },
                description: {

                },
                adresse: {

                },
                logo:{

                }
            }
        },
        created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },

        mounted() {
            //
        }
    }
</script>

<style scoped>

</style>